import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbSftp: BowlBlock = withIntegration(options.slug.llmKbSftp, [
  {
    name: 'remoteUrl',
    type: 'withText',
    required: true,
  },
  {
    name: 'host',
    type: 'withText',
  },
  {
    name: 'port',
    type: 'number',
  },
  {
    name: 'username',
    type: 'withText',
    required: true,
  },
  {
    name: 'password',
    type: 'withText',
    required: true,
  },
  {
    name: 'recursive',
    type: 'checkbox',
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
